import { render, staticRenderFns } from "./modalEliminarProducto.vue?vue&type=template&id=5707ef0d&scoped=true"
import script from "./modalEliminarProducto.vue?vue&type=script&lang=js"
export * from "./modalEliminarProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707ef0d",
  null
  
)

export default component.exports